export default {
  hello: "{msg} world",
  test: "Test",
  "Bestanden": "Files",
};
